import React, {useState} from "react"
import useAuth from "@irati/auth/helpers/auth/useAuth"
import FormattedMessage from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import styled from "styled-components"
import mainTheme from "@irati/ui/src/global/theme"
import {FamilyFriendsPopup} from "../FamilyFriendsPopup"
const Container = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  gap: ${mainTheme.spacing.two};
  padding: ${mainTheme.spacing.two};
  background-color: ${mainTheme.colors.primary1};
`
const LocationsToShow = ["/wallet/flexi-points", "/wallet/reward-points", "/wallet/custom-rewards"]
export const InviteFamilyFriendBanner = () => {
  const auth = useAuth()
  const [showPopup, setShowPopup] = useState(false)
  const isFFOff = auth.business?.featureFlags.includes("FriendsAndFamilyOff")
  if (LocationsToShow.indexOf(location.pathname) === -1 || isFFOff) {
    return null
  }
  return (
    <Container>
      <Body color="white" maxWidth="100%">
        <FormattedMessage id="wallet.friendsFamilyBanner.msg" values={{tenant: auth.business?.businessName}} />
      </Body>
      <Button small onClick={() => setShowPopup(true)} primary inverted>
        <FormattedMessage id="wallet.friendsFamilyBanner.action" />
      </Button>
      <FamilyFriendsPopup showPopup={showPopup} onHide={() => setShowPopup(false)} />
    </Container>
  )
}
